import { Component, OnInit, Input, OnChanges, SimpleChange, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Adal5Service } from 'adal-angular5';
import { Subscription } from 'rxjs/Subscription';
import { LocalCacheService } from '../../../../core/local-cache/local-cache.service';
import { SharedCallsService } from '../../../../../app/shared/services/shared-calls.service';
import { SubheaderHandlerService } from '../../../../shared/services/subheader-handler.service';
import { Router } from '@angular/router';
import { LoggerService } from '../../../../core/logger/global-logger.service';
import { TimeoutHandlerService } from '../../../../shared/services/timeout-handler.service';
import '../../../../../assets/js/userVoice.js';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss']
})
export class SideBarComponent implements OnInit, OnChanges, OnDestroy {
  translatedText = [];
  isAdmin: boolean;
  isMarketer: boolean;
  currentPageNameSubscription: Subscription;
  public loading = true;
  lockStatus: boolean;
  currentPageName: string;
  caseId: string;
  isLoading: boolean;
  lockedBySameUser: boolean;
  caseStatus: string;
  enablePageNameSubscription: Subscription;
  enableSaveProgress = false;
  constructor(
    private sharedSerice: SharedCallsService,
    private storage: LocalCacheService,
    private adalSvc: Adal5Service,
    private translate: TranslateService,
    private route: Router,
    private logger: LoggerService,
    private timeoutService: TimeoutHandlerService,
    private subHeaderService: SubheaderHandlerService) {
    translate.get([
      'SIDE_BAR.MAPS',
      'SIDE_BAR.VALUE_TRACKER',
      'SIDE_BAR.USERS',
      'SIDE_BAR.EXIT'
    ]).subscribe((translations: string) => {
      this.translatedText[0] = translations['SIDE_BAR.MAPS'];
      this.translatedText[1] = translations['SIDE_BAR.VALUE_TRACKER'];
      this.translatedText[2] = translations['SIDE_BAR.USERS'];
      this.translatedText[3] = translations['SIDE_BAR.EXIT'];
    });
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.lockStatus !== undefined && changes.lockStatus.currentValue !== undefined) {
      this.lockStatus = changes.lockStatus.currentValue;
    }
  }

  ngOnInit() {
    this.fetchUserRole();
    this.currentPageNameSubscription = this.subHeaderService.currentPageName$.subscribe((pageNameCaseId) => {
      this.getDetailsForUserAndCase(pageNameCaseId);
      this.updateCurrentPageName(pageNameCaseId);
    });
    this.enablePageNameSubscription = this.subHeaderService.enableSaveProgress$.subscribe(
      (enableSaveProgress) => {
          this.enableSaveProgressForPage(enableSaveProgress);
      });
  }

  enableSaveProgressForPage(enableSaveProgress: boolean) {
    this.enableSaveProgress = enableSaveProgress;
}

updateCurrentPageName(pageNameCaseId: any) {
  this.currentPageName = pageNameCaseId.pageName;
}
  fetchUserRole() {
    this.sharedSerice.getUserRole(this.adalSvc.userInfo.username + '/').subscribe(response => {
      if (response.status === 200) {
        this.storage.storeData('userRole', response.result.roleName, 'session');
        this.isAdmin = (response.result.roleName.toLowerCase() === 'admin');
        this.isMarketer = (response.result.roleName.toLowerCase() === 'marketer');
      }
    });
  }

  getDetailsForUserAndCase(pageNameCaseId) {
    let userId = '';
    userId = this.storage.fetchData('userId');
    if (!userId || userId === '') {
      this.sharedSerice.getUserRole(this.adalSvc.userInfo.username + '/').subscribe(response => {
        if (response.status === 200) {
          this.storage.storeData('userRole', response.result.roleName, 'session');
          this.isAdmin = (response.result.roleName.toLowerCase() === 'admin');
          this.isMarketer = (response.result.roleName.toLowerCase() === 'marketer');
          this.updatePageName(pageNameCaseId);
        }
      });
    } else {
      this.updatePageName(pageNameCaseId);
    }
  }

  private showToaster(type: string, msg: string) {
    if (type === 'success') {
      this.logger.success({ message: msg }, true, true);
    } else {
      this.logger.warning({ message: msg }, true, true);
    }
  }

  updatePageName(pageNameCaseId: any) {
    this.currentPageName = pageNameCaseId.pageName;
    if (this.currentPageName === 'evaluator') {
      // Browser back on dashboard
      this.lockStatus = false;
      this.caseStatus = undefined;
      this.subHeaderService.updateCaseStatus({ caseStatus: this.caseStatus, pageName: this.currentPageName });
    } else if (pageNameCaseId.caseId) {
      this.caseId = pageNameCaseId.caseId;
      // For refresh of page
      this.sharedSerice.getCaseLockStatus(this.caseId).subscribe(response => {
        if (response.status === 200) {
          this.lockStatus = response.result.isCaseLocked;
          this.caseStatus = response.result.caseStatus;
          const message = response.result.message;
          this.setSourceOfRedirection();
          const errorMessage = this.timeoutService.getLockMessage(this.lockStatus, message).errorMessage;
          if (errorMessage !== '') {
            this.showToaster('Error', errorMessage);
            this.route.navigate(['/evaluator']);
          } else if ((!this.lockStatus &&
            (message === 'lockedbysameuserbutlockexpired' || message === 'lockexpired' || message === 'notlocked'))
            || (this.lockStatus && response.result.message === 'lockedbysameuser')
          ) {
            const lockId = this.storage.fetchData('lockId');
            if (!lockId && response.result.message === 'lockedbysameuser') {
              this.storage.storeData('lockId', response.result.id);
            }
            const caseId = this.storage.fetchData('caseId');
            if (!caseId && response.result.message === 'lockedbysameuser') {
              this.storage.storeData('caseId', this.caseId);
            }
            this.timeoutService.createLock(this.caseId).subscribe(lockDetails => {
              if (lockDetails !== '') {
                this.lockStatus = true;
                this.subHeaderService.updateLockStatus(this.lockStatus);
                this.redirectBasedOnCaseState();
              } else {
                this.route.navigate(['/evaluator']);
                this.showToaster('Error', 'Error occured.');
              }
            });
          }
          // else if (this.lockStatus && response.result.message === 'lockedbysameuser') {
          //   this.lockStatus = true;
          //   this.setSourceOfRedirection();
          //   this.redirectBasedOnCaseState();
          // }
          this.subHeaderService.updateLockStatus(this.lockStatus);
          this.subHeaderService.updateCaseStatus({ caseStatus: this.caseStatus, pageName: this.currentPageName });
          this.subHeaderService.enableSaveProgressForPage(this.enableSaveProgress);
        }
      });
    } else {
      this.caseStatus = undefined;
      this.subHeaderService.updateCaseStatus({ caseStatus: this.caseStatus, pageName: this.currentPageName });
      this.subHeaderService.enableSaveProgressForPage(this.enableSaveProgress);
    }
  }

  setSourceOfRedirection() {
    const previosSourceOfRedirection = JSON.parse(this.storage.fetchData('sourceOfEditCase', 'session'));
    if (previosSourceOfRedirection) {
      this.storage.clearData('sourceOfEditCase', 'session');
    }
    // update the current status of the case in localstorage
    const sourceOfEditCase = {
      fromPage: 'Dashboard',
      caseId: this.caseId,
      caseStatus: this.caseStatus
    };
    this.storage.storeData('sourceOfEditCase', JSON.stringify(sourceOfEditCase), 'session');
  }

  redirectBasedOnCaseState() {
    if (this.currentPageName === 'newSolutions' || this.currentPageName === 'solutionCustomerPerformanceGaps'
      || this.currentPageName === 'solutionLanding' || this.currentPageName === 'solutionCaseDetails') {
      if (this.caseStatus === 'Draft') {
        this.route.navigate(['/evaluator/case/' + this.caseId]);
      } else if (this.caseStatus === 'Pending' || this.caseStatus === 'Terminated') {
        this.route.navigate(['/evaluator/case/' + this.caseId + '/customerperformancegapvalue']);
      }
    }
  }


  ngOnDestroy() {
    this.currentPageNameSubscription.unsubscribe();
    this.enablePageNameSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/components/shared/layout/side-bar/side-bar.component.ts